// import request from '@/services/request'
// import api from '@/services/api'
const state = {
  settlementId: '', // amazon 记录跳转结算明细页面
  exceptionStatus: '', // shopee 异常订单标识
  goSettlementAmazonParams: {},
  profitdata: {}
}

const mutations = {
  SET_SETTLEMENTID: (state, data) => {
    state.settlementId = data
    console.log(1212)
  },
  SET_EXCEPTIONSTATUS: (state, data) => {
    state.exceptionStatus = data
  },
  SET_GOSETTLEMENTAMAZONPARAMS: (state, data) => {
    state.goSettlementAmazonParams = data
  },
  SET_PROFITDATA(state, data) {
    state.profitdata = data
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
